<div class="dialog">
  <div class="dialog__header">
    <h3 class="dialog__title">
      {{ title() }}
      @if (titleSuffix) {
        <span class="dialog__title-suffix">{{ titleSuffix }}</span>
      }
    </h3>
    <svg-icon src="assets/images/icons/x.svg" class="dialog__close" (click)="closeDialog()" />
  </div>
  @if (!selfServiceStatus()) {
    <selfservice-unavailable [title]="'Selfservice.Global.Engine'" class="dialog__grow-wrapper" />
  } @else {
    @if (subscription() && !auth.isCurrentOrganisation(customerId())) {
      <div>{{ "Global.NoAccess" | translate }}</div>
    } @else {
      @if (subscription() && !insync()) {
        <selfservice-unavailable class="dialog__grow-wrapper" />
      }

      @if (!loader && insync() && !success) {
        @if (data.type === "ddos" && isIp(subscription())) {
          <selfservice-ddos class="dialog__grow-wrapper" [subscription]="ipSubscriptionDetails" [bus]="communication" />
        }

        @if (data.type === "rps") {
          <selfservice-rps
            class="dialog__grow-wrapper"
            [subscription]="lightpathSubscriptionDetails"
            [bus]="communication"
          />
        }

        @if (data.type === "sp") {
          <selfservice-speedpolicer
            class="dialog__grow-wrapper"
            [subscription]="selfServiceSpCompatible"
            [bus]="communication"
          />
        }

        @if (data.type === "bfd") {
          <selfservice-bfd
            class="dialog__grow-wrapper"
            [subscription]="ipBgpSubscriptionDetails"
            [instance]="instance"
            [sapIndex]="sapIndex()"
            [bus]="communication"
          />
        }

        @if (data.type === "graceful-restart") {
          <selfservice-graceful-restart
            class="dialog__grow-wrapper"
            [subscription]="ipBgpSubscriptionDetails"
            [instance]="instance"
            [sapIndex]="sapIndex()"
            [bus]="communication"
          />
        }

        @if (data.type === "bgp") {
          <selfservice-bgp class="dialog__grow-wrapper" [subscription]="ipSubscriptionDetails" [bus]="communication" />
        }

        @if (data.type === "ip-prefixes") {
          <selfservice-ip-prefixes
            class="dialog__grow-wrapper"
            [subscription]="ipSubscriptionDetails"
            [initialSapIndex]="sapIndex()"
            [bus]="communication"
            [selectedPrefix]="data.selectedPrefix"
          />
        }

        @if (!success && data.type === "autoMitigation") {
          <selfservice-ddos-auto-mitigation
            class="dialog__grow-wrapper"
            [subscription]="subscription()"
            [bus]="communication"
            [mitigationState]="data.mitigationState"
          />
        }

        @if (data.type === "add-port") {
          <selfservice-add-port
            class="dialog__grow-wrapper"
            [subscription]="l2vpnSubscriptionDetails"
            [bus]="communication"
          />
        }

        @if (data.type === "remove-port") {
          <selfservice-remove-port
            class="dialog__grow-wrapper"
            [subscription]="l2vpnSubscriptionDetails"
            [bus]="communication"
          />
        }

        @if (data.type === "vlan-lightpath") {
          <selfservice-vlan-lightpath
            class="dialog__grow-wrapper"
            [subscription]="lightpathSubscriptionDetails"
            [bus]="communication"
          />
        }

        @if (data.type === "vlan-l2vpn") {
          <selfservice-vlan-l2vpn
            class="dialog__grow-wrapper"
            [subscription]="l2vpnSubscriptionDetails"
            [bus]="communication"
          />
        }
      }

      @if (loader && !success) {
        <selfservice-loader class="dialog__grow-wrapper" [processId]="processId" [bus]="loadCommunication" />
      }

      @if (success) {
        <selfservice-success class="dialog__grow-wrapper" />
      }
    }
  }
</div>
